<template>
  <admin-page-shell :title="$t('frontend_groovemail_admin_smpt_settings_header')">
    <server-table
      class="text-center groovemail-admin-smtp-table"
      ref="serverTable"
      :url="smtpListingUrl"
      tableRef="smtpTable"
      tableTitle="frontend_groovemail_admin_smpt_settings_header"
      :slotData="smtpSlotData"
      :tableColumns="smtpSettingTableColumns"
      :tableOptions="smtpSettingTableOptions"
      :firstSelectedFilter="poolFilterType"
      firstFilterName="frontend_groovemail_smtp_select_pool_level"
      :firstFilterData="poolFilterData"
      :secondSelectedFilter="tierFilterType"
      secondFilterName="frontend_groovemail_smtp_select_tier_level"
      :secondFilterData="tierFilterData"
      addNewBtnText="frontend_groovemail_smtp_new"
      @addNewData="openCreateSetting"
      @firstFilterUpdated="poolFilterUpdated"
      @secondFilterUpdated="tierFilterUpdated"
      @loaded="hideLoader()"
      @loading="showLoader()"
    >
    </server-table>

    <gs-named-modal
      id="send-email-from-smtp-modal"
      name="send-email-from-smtp-modal"
      :title="this.$t('frontend_groovemail_sequence_action_send_email')"
    >
      <div class="gm-admin-modal__body">
        <gs-field :label="$t('frontend_groovemail_admin_settings_enter_email')">
          <text-input
            variant="base"
            v-model="model.smtpEmail"
            :placeholder="this.$t('frontend_groovemail_admin_settings_enter_email')"
            :validator="$v.model.smtpEmail"
          />
        </gs-field>
        <div class="gm-admin-modal__footer">
          <gs-button variant="outline" @click="closeSendMailViaSmtpModal()">{{ $t('frontend_cancel') }}</gs-button>
          <gs-button variant="primary" @click="sendEmailViaSmtpToTest()">{{ this.$t('frontend_send') }}</gs-button>
        </div>
      </div>
    </gs-named-modal>

    <!-- Confirmation delete modal -->
    <confirm-modal
      :ref="`confirmation-delete-setting`"
      :name="`confirmation-delete-setting`"
      :buttonText="$t('frontend_confirm')"
      :cancelText="$t('frontend_cancel')"
      :confirmMessage="this.$t('frontend_bouses_delete_bonus_title')"
      :messageContent="this.$t('frontend_groovemail_swal_revert_message')"
      @confirm="deleteSetting"
      @close="closeDeleteSettingModal"
    />
  </admin-page-shell>
</template>

<script>
import axios from 'axios';
import { mapActions } from 'vuex';
import ServerTable from '@groovepages/gd-ui-kit/components/tables/ServerTable.vue';
import AdminPageShell from '../AdminPageShell.vue';
import { required, minLength, maxLength, email,} from 'vuelidate/lib/validators';
import { adminUrls } from '@/utils/urls.js';
import { getData, postData, deleteData } from '@/utils/apiHelper.js';
import {showRequestErrorAlert, showSuccessDialog} from '@/components/showDialog.js';
import demoModeValuesMixin from '@/mixin/demoModeValuesMixin.js';

let self;

export default {
  middleware: 'auth',
  metaInfo() {
    return { title: this.$t('frontend_groovemail_admin_smpt_settings_header') };
  },

  mixins: [demoModeValuesMixin],

  data() {
    return {
      smtpListingUrl: adminUrls.smtpUrl.smtpData,
      model: {
        smtpEmail: '',
      },
      confirmId: null,
      poolFilterType: '',
      tierFilterType: '',
      poolFilterData: [],
      tierFilterData: [],
      smtpSettingTableColumns: [
        'smtp_name',
        'pool_type_id',
        'smtp_type_id',
        'mail_host',
        'mail_port',
        'mail_enc',
        'mail_username',
        'mail_sent_past_one_hours',
        'mail_sent_past_twenty_four_hours',
        'total_mail_sent',
        'actions',
      ],
      smtpSettingTableOptions: {
        perPage: 10,
        debounce: 1000,
        alwaysShowPerPageSelect: true,
        perPageValues: [10, 25, 50, 100],
        pagination: { chunk: 5 },
        sortIcon: {
          base: 'fa',
          is: 'fa-sort',
          up: 'fa-sort-asc',
          down: 'fa-sort-desc',
        },
        customFilters: ['pool_filter_id', 'smtp_filter_id'],
        headings: {
          smtp_name: () => this.$t('frontend_groovemail_smtp_index_name'),
          pool_type_id: () => this.$t('frontend_groovemail_smtp_index_pool'),
          smtp_type_id: () => this.$t('frontend_groovemail_smtp_index_tier'),
          mail_host: () => this.$t('frontend_groovemail_smtp_index_mail_host'),
          mail_port: () => this.$t('frontend_groovemail_smtp_index_mail_port'),
          mail_enc: () =>
            this.$t('frontend_groovemail_smtp_index_mail_encryption'),
          mail_username: () =>
            this.$t('frontend_groovemail_smtp_index_mail_username'),
          mail_sent_past_one_hours: () =>
            this.$t('frontend_groovemail_smtp_mail_sent_one_hour'),
          mail_sent_past_twenty_four_hours: () =>
            this.$t('frontend_groovemail_smtp_mail_sent_twenty_four_hour'),
          total_mail_sent: () =>
            this.$t('frontend_groovemail_smtp_mail_sent_total'),
        },
        texts: {
          filterPlaceholder: this.$t('frontend_groovemail_tables_search_query'),
        },
        filterable: [
          'smtp_name',
          'mail_host',
          'mail_port',
          'mail_enc',
          'mail_username',
        ],
        sortable: [
          'smtp_name',
          'mail_host',
          'mail_port',
          'mail_enc',
          'mail_username',
          'mail_sent_past_one_hours',
          'mail_sent_past_twenty_four_hours',
          'total_mail_sent',
        ],
        requestFunction(data) {
          const requestParams = { ...data, ascending: 1 - data.ascending };
          const self = this;
          return axios
            .get(self.url, {
              params: requestParams,
            })
            .catch((e) => {
              self.dispatch('error', e);
            });
        },
        responseAdapter({ data }) {
         if(self.demoMode) {
            const newData = data[0]?.data.map((obj) => ({
              ...obj,
              mail_host: self.basicMailHostText,
              mail_password: self.basicText,
              mail_port: self.basicText,
              mail_username: self.basicText,
              smtp_name: self.basicText
            }));

            return {
              data: newData,
              count: newData.length,
            };
          }
          return {
            data: data[0].data,
            count: data[0].total,
          };
        },
      },
    };
  },

  components: {
    AdminPageShell,
    ServerTable,
  },
  

  validations: {
    model: {
      smtpEmail: {
        required,
        email,
        minLength: minLength(3),
        maxLength: maxLength(150),
      },
    },
  },

  methods: {
    ...mapActions('loader', ['LOADING']),

    // show loader
    showLoader() {
      this.LOADING(true);
    },

    // hide loader
    hideLoader (){
      this.LOADING(false);
    },

    /**
     * Used to open a modal to send test email.
     * @param {string} smtpId unique id of smtp data to test.
     */
    sendEmailViaSmtp(smtpId) {
      this.$root.$emit('modal-open', 'send-email-from-smtp-modal');
      this.model.smtpEmail = '';
      this.$v.model.smtpEmail.$reset();
      this.currentSmtp = smtpId;
    },

    // Used to close a modal which sends test email.
    closeSendMailViaSmtpModal() {
      this.$root.$emit('modal-close', 'send-email-from-smtp-modal');
    },
    
    // Sends email to test
    async sendEmailViaSmtpToTest() {
      this.$v.model.smtpEmail.$touch();
      const emailValid = !this.$v.model.smtpEmail.$invalid;
      if (emailValid) {
        const sendEmailRequestData = {
          smtp_id: this.currentSmtp,
          send_to_email: this.model.smtpEmail,
        };
        const mailSendRes = await postData(adminUrls.smtpUrl.sendTestMailForSMTP, sendEmailRequestData);
        this.$root.$emit('modal-close', 'send-email-from-smtp-modal');
        this.model.smtpEmail = '';
        this.$v.model.smtpEmail.$reset();
        if (mailSendRes.data.status === 400) {
          await showRequestErrorAlert(this.$t('frontend_groovemail_smtp_mail_sent_error_message'),);
        } else if (mailSendRes.data.status === 200) {
          await showSuccessDialog(
            this.$t('frontend_groovemail_smtp_mail_sent_success_message'),
            mailSendRes.data.message
          );
        }
      }
    },

    // Opens a page where user can create a new smtp settigs.
    openCreateSetting() {
      this.$router.push({ name: 'NewAdminSmtp' });
    },

    /**
     * Opens a page where user can edit already present smtp settigs.
     * @param {string} id unique id of a smtp data.
     */
    openEditSetting(id) {
      this.$router.push({ name: 'EditAdminSmtp', params: { id } });
    },

    // open delete Setting modal
    async openDeleteSettingModal(id) {
      // set the Confirm id
      this.confirmId = id;

      // open the modal
      this.$refs[`confirmation-delete-setting`].open();
    },

    // close delete Setting modal
    closeDeleteSettingModal() {
      // reset the Confirm id
      this.confirmId = null;
    },

    // delete setting
    async deleteSetting() {
      try {
        await deleteData(
          `${adminUrls.smtpUrl.smtpData}/${this.confirmId}`
        );
        const smtpData = await getData(
          `${adminUrls.smtpUrl.smtpData}?query=${this.$refs.serverTable.$refs.smtpTable.filteredQuery}&limit=${this.smtpSettingTableOptions.perPage}&page=${this.$refs.serverTable.$refs.smtpTable.Page}&pool_filter_id=${this.$refs.serverTable.$refs.smtpTable.customQueries.pool_filter_id}&smtp_filter_id=${this.$refs.serverTable.$refs.smtpTable.customQueries.smtp_filter_id}&ascending=1&byColumn=0`
        );
        this.$refs.serverTable.updateData(
          smtpData?.data[0]?.data,
          smtpData?.data[0]?.total
        );

      } catch (error) {
        showRequestErrorAlert(error?.response?.data?.error);
      }
    },

    /**
     * Apply filter & fetches tier filter data based on pool filter type value.
     * @param {object} event object which contains updated pool fiter type id.
     */
    async poolFilterUpdated(event) {
      this.tierFilterType = '';
      this.poolFilterType = event;

      this.$refs.serverTable.$refs.smtpTable.customQueries.smtp_filter_id = '';

      if (event) {
        const smtpTierTypeRequestData = {
          pool_id: event,
        };

        try {
          const tierData = await postData(adminUrls.smtpUrl.smtpTierTypes, smtpTierTypeRequestData);

          // set pool data to data properties
          const data = tierData && tierData.data;

          // stop if no data is present
          if(data.length === 0) {
            return;
          }

          data.forEach((element) => {
            this.tierFilterData.push({ text: element.name, value: element.id});
          });
        } catch (error) {
          showRequestErrorAlert(error?.response?.data?.error);
        }

        this.$refs.serverTable.$refs.smtpTable.customQueries.pool_filter_id =
          event;

      } else {
        this.tierFilterData = [];
        this.$refs.serverTable.$refs.smtpTable.customQueries.pool_filter_id = '';
      }
      this.$refs.serverTable.$refs.smtpTable.refresh();
    },

    /**
     * Applied filter based on tier filter type value.
     * @param {object} event object which contains updated tier fiter type id.
     */
    tierFilterUpdated(event) {
      if (event) {
        this.$refs.serverTable.$refs.smtpTable.customQueries.smtp_filter_id = event;
      } else {
        this.$refs.serverTable.$refs.smtpTable.customQueries.smtp_filter_id = '';
      }
      this.$refs.serverTable.$refs.smtpTable.refresh();
    },

    // Fetches pool data and initializes them to data properties.
    async initializePoolData() {
      const poolData = await getData(adminUrls.smtpUrl.smtpPoolTypes);

      // Set pool data to data properties.
      const data = poolData && poolData.data;

      // stop if no data is present
      if(data.length === 0) {
        return;
      }

      // Set pool data to data properties.
      data.forEach((element) => {
        this.poolFilterData.push({ text: element.name, value: element.id});
      });
    },
  },

  async created() {
    self = this;
    await this.initializePoolData();
  },

  watch: {
    // Used to refresh smtp table when demo mode changes
    demoMode() {
      this.$refs.serverTable.$refs.smtpTable.refresh();
    },
  },

  computed: {
    // Used to return demoMode value from store.
    demoMode() {
      return this.$store.state.demoMode.isDemoMode;
    },
    
    /**
     * Returns slot data for smtp table.
     * @return {array} details for slot columns for smtp table.
     */
    smtpSlotData() {
      return [
        {
          slotName: 'mail_enc',
          slotType: 'computed',
          classes: () => {
            return '';
          },
          value: (props) => {
            return props.row.mail_enc
              ? props.row.mail_enc
              : this.$t('frontend_groovemail_not_available');
          },
        },
        {
          slotName: 'mail_sent_past_one_hours',
          slotType: 'computed',
          classes: () => {
            return '';
          },
          value: (props) => {
            return props.row.mail_sent_past_one_hours
              ? props.row.mail_sent_past_one_hours
              : 0;
          },
        },
        {
          slotName: 'mail_sent_past_twenty_four_hours',
          slotType: 'computed',
          classes: () => {
            return '';
          },
          value: (props) => {
            return props.row.mail_sent_past_twenty_four_hours
              ? props.row.mail_sent_past_twenty_four_hours
              : 0;
          },
        },
        {
          slotName: 'total_mail_sent',
          slotType: 'computed',
          classes: () => {
            return '';
          },
          value: (props) => {
            return props.row.total_mail_sent ? props.row.total_mail_sent : 0;
          },
        },
        {
          slotName: 'actions',
          slotType: 'actions',
          conditions: () => {
            return true;
          },
          classes: () => {
            return {
              outerDiv: '',
              dropdown: '',
              outerSpan: '',
            };
          },
          actionList: [
            {
              id: 0,
              name: () => this.$t('frontend_edit'),
              conditions: () => {
                return true;
              },
              callback: (props) => this.openEditSetting(props.row.id),
            },
            {
              id: 1,
              name: () => this.$t('frontend_groovemail_sequence_action_send_email'),
              conditions: () => {
                return true;
              },
              callback: (props) => this.sendEmailViaSmtp(props.row.id),
            },
            {
              id: 2,
              name: () => this.$t('frontend_delete'),
              conditions: () => {
                return true;
              },
              callback: (props) => this.openDeleteSettingModal(props.row.id),
            },
          ],
        },
      ];
    },
  },
};
</script>


<style lang="scss">
.groovemail-admin-smtp-table #gd-server-table-view {
  .VueTables--server table {
    td:nth-child(1),
    th:nth-child(1),
    td:nth-child(4),
    th:nth-child(4),
    td:nth-child(7),
    th:nth-child(7) {
      width: 12%;
    }
    td:nth-child(2),
    th:nth-child(2),
    td:nth-child(3),
    th:nth-child(3),
    td:nth-child(5),
    th:nth-child(5),
    td:nth-child(6),
    th:nth-child(6),
    td:nth-child(8),
    th:nth-child(8),
    td:nth-child(9),
    th:nth-child(9),
    td:nth-child(10),
    th:nth-child(10) {
      width: 8%;
    }
  }
}
</style>
